import React, { useEffect, useState } from "react";
import { Header } from "../header";
import { useParams } from "react-router-dom";
import TableCart from "./TableCart/TableCart";
import { useTranslation } from "react-i18next";
import {
  calculateTotal,
  getCartItems,
  removeFromCart,
  updateQuantity,
} from "../utils/CartFunctions";
import { ShoppingCart } from "lucide-react";
import Visibility from "../utils/Visibility";
import OptSend from "./OptSend";
import { indexStore } from "../../store/indexStore";
import { BrowseProducts, CheckoutComponent } from "./Tools";
import IsNotActive from "../IsNotActive/IsNotActive";
import ProductModel from "../../Models/PorductModel";

function Cart() {
  const params = useParams();
  const { style, getStyle, restaurant, fetchBranchesAction } = indexStore();
  const [cartItems, setCartItems] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (style) {
      getStyle(params);
    }
    if (restaurant) fetchBranchesAction({ domain: params.domain });
    loadCart();
  }, []);

  // تحميل العربة وتحديث الإجمالي
  const loadCart = () => {
    const items = getCartItems(Number(params.branch_id));
    setCartItems(items);
    setTotal(calculateTotal(Number(params.branch_id)));
  };

  // تحديث الكمية
  const handleUpdateQuantity = (product: ProductModel, newQuantity: number) => {
    updateQuantity(product, newQuantity, Number(params.branch_id));
    loadCart();
  };

  // حذف عنصر
  const handleRemoveItem = (product: ProductModel) => {
    removeFromCart(product, Number(params.branch_id));
    loadCart();
  };

  const { t } = useTranslation();
  console.log(cartItems);

  return (
    <IsNotActive>
      <div className="flex flex-col flex-grow bg-background">
        <title>{params?.domain?.toUpperCase()}</title>
        <Header noBack={false} backgroundColorfull={true} />
        <Visibility visible={cartItems.length == 0}>
          <EmptyCart params={params} t={t} />
        </Visibility>

        <Visibility visible={cartItems.length > 0}>
          <div className=" flex flex-col pb-20 gap-4">
            <div className={`bg-primary rounded-b-3xl p-3 pb-5`}>
              <div className="flex flex-row justify-between items-center">
                <h3 className="text-3xl font-bold text-onPrimary">
                  {t("gloabl.Cart")}
                </h3>
                <BrowseProducts
                  params={params}
                  t={t}
                  className={"!bg-onPrimary text-primary"}
                />
              </div>
            </div>
            <div className="p-4 flex flex-col  gap-4">
              <TableCart
                data={cartItems}
                handleUpdateQuantity={handleUpdateQuantity}
                handleRemoveItem={handleRemoveItem}
              />

              <CheckoutComponent
                cartItems={cartItems}
                total={total}
                t={t}
                params={params}
                loadCart={loadCart}
              />
            </div>
          </div>
        </Visibility>
      </div>
    </IsNotActive>
  );
}

export default Cart;

const EmptyCart = ({ params, t }: any) => {
  return (
    <div className="flex flex-col gap-3 items-center justify-center h-full text-center p-8">
      <ShoppingCart className="w-24 h-24 text-gray-400" />
      <h2 className="text-2xl font-bold text-onBackground-600 mt-4">
        {" "}
        {t("gloabl.emptyCart")}
      </h2>
      <p className="text-onBackground-500 mt-2">
        {t("gloabl.emptyCartMessage")}
      </p>
      <BrowseProducts params={params} t={t} />
    </div>
  );
};
